export default "__VITE_ASSET__zCFkCcAF__"